<template>
  <el-dialog
    v-loading="loading"
    class="passport-modal"
    width="90%"
    title="商户子账号"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="true"
  >
    <div>
      <div v-for="(p, idx) in passports" :key="p.id" class="passport-item">
        <div v-if="p.roleId === 1 || idx === 0" class="main-badge">
          <i class="el-icon-star-on"></i>主账号
        </div>
        <div class="field">
          <label>手机号</label><div>{{ p.userName }}</div>
        </div>
        <div class="field">
          <label>名称</label><div>{{ p.passportName }}</div>
        </div>
        <div class="field">
          <label>查询权限</label><div>{{ p.epcable ? '有' : '无' }}</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import { loadCustomerPassport } from '../services'
export default {
  name: 'PassportModal',
  mixins: [ModalMixin],
  data () {
    return {
      loading: false,
      passports: []
    }
  },
  methods: {
    init (companyId) {
      this.loadData(companyId)
      return this.open()
    },
    loadData (companyId) {
      this.loading = true
      loadCustomerPassport(companyId).then((resp) => {
        this.passports = resp
      }).catch(() => {
        this.close(false)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="stylus">
.passport-modal
  .el-dialog
    max-width 560px
    .el-dialog__body
      padding-top 0
      max-height 640px
      overflow-x hidden
      overflow-y auto
      .passport-item
        margin-bottom 8px
        position relative
        .main-badge
          position absolute
          top 0
          right 0
          color #ff0000
        .field
          display flex
          flex-direction row
          label
            width 70px
            text-align right
            flex-shrink 0
            font-weight bold
            &:after
              content '\ff1a'
        +.passport-item
          border-top 1px dashed #ff6600
          padding-top 8px
</style>
